window.SKEI_AD_PROMOS = {
  promos: {
    "damen-mix-v5-paradoxe": {
      name: "Damen Mix V5 Paradoxe",
      products: [
"sambac-blanc",
        "lily-of-the-valley",
        "rhurbarb-rose",
        "floral-cashmere",
        "cocoa-cashmere",
        "vanille-intense",
        "floral-violet",
        "creme-cashmere",
        "agrume-aquatique",
        "gardenia-douce",
        "neroli-sucre"
      ]
    },

     "damen-mix-v4-good-girl": {
      name: "Damen Mix V4 Good Girl",
      products: [
"cocoa-cashmere",
"floral-cashmere",
"rhurbarb-rose",
"sambac-blanc",
"vanille-intense",
"honey-blossom",
"golden-gardenia",
"lily-of-the-valley",
"orchid-vanilla",
"osmanthus-musk",
"bouquet-poudre"
      ]
    },

    "damen-mix-v6-delina": {
      name: "Damen Mix V6 Delina",
      products: [
"rhurbarb-rose",
        "fleur-poudree",
        "osmanthus-musk",
        "floral-violet",
        "mandarin-musk",
        "creme-blanche",
        "neroli-sucre",
        "giacinto-bianco",
        "gardenia-douce",
        "honey-spice",
        "rose-coumarine"
      ]
    }
  },



  
adIdMap: {
    "damen-mix-v5-paradoxe": [
      "120237303580300352",
      "120237303580300999"
    ],

    "herren-mix-v3-sauvage": [
      "120237303580300111",
      "120237303580300222",
      "120237303580300333"
    ]
  }
};